var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.subject.furigana)?_c('v-col',{staticClass:"my-1 mx-0 px-0",attrs:{"cols":"6","xs":"6","sm":"4","md":"3"}},[_c('base-button',{staticClass:"subject-button",style:({
      backgroundColor: _vm.subject.backgroundColor,
      color: _vm.subject.color,
      border:
        _vm.subject.color !== 'white'
          ? ("1px solid " + (_vm.subject.color))
          : 'none'
    }),on:{"click":function($event){return _vm.$emit('scrollToAnchorPoint', _vm.subject.anchor)}}},[_c('div',{staticClass:"anchor-title",attrs:{"align":"center","justify":"center"}},[_c('div',{staticClass:"subject-move__button",domProps:{"innerHTML":_vm._s(_vm.subject.furigana)}})]),_c('v-icon',{staticClass:"icon-arrow",attrs:{"dark":"","right":""}},[_vm._v(" mdi-chevron-down ")])],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }